import PlaceholderSvg from '@assets/images/svg/placeholder.svg';
import React from 'react';
import { StyleSheet, View, ViewStyle } from 'react-native';

export interface PlaceholderImageProps {
    style?: ViewStyle;
}

export function PlaceholderImage({ style }: PlaceholderImageProps) {
    return (
        <View style={[styles.container, style]}>
            <PlaceholderSvg width={40} height={40} />
        </View>
    );
}

const styles = StyleSheet.create({
    container: {
        overflow: 'hidden',
        flex: 1,
        width: '100%',
        height: '100%',
        backgroundColor: '#E3E3E3',
        alignItems: 'center',
        justifyContent: 'center',
    },
});

export default PlaceholderImage;


